import { render, staticRenderFns } from "./ResizeObserver.vue?vue&type=template&id=624b2086&"
import script from "./ResizeObserver.js?vue&type=script&lang=js&"
export * from "./ResizeObserver.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_@babel+core@7.23.2_supports-color@9.4.0____229d748864a9179315425c36c303c267/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports